import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Importação do Bootstrap
import { Modal } from 'react-bootstrap';
// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import DatePicker from 'react-bootstrap-date-picker';

class StaffsMateriaMinistradaTab extends Component {
  // Constructor
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      'dados': [],
      'dados_modal_materias': [],
      'dados_export_modal_materias': [],
      'titulo_modal_treinamento': [],
      'team_training_matter_staff_ids': [],
      'modal': false,
      'modal_input': false,
    };
    this.showModal = this.showModal.bind(this);
    this.botaoAcoes = this.botaoAcoes.bind(this);
    this.verifyRPA = this.verifyRPA.bind(this);
    this.exportRPA = this.exportRPA.bind(this);
    this.handleChangeDateStartPicker = this.handleChangeDateStartPicker.bind(this);
    this.handleChangeDateFinishPicker = this.handleChangeDateFinishPicker.bind(this);
    this.toggleCheckbox = this.toggleCheckbox.bind(this);
  }

  // LM
  componentWillReceiveProps(newProps) {
    if(Array.isArray(newProps.aulas_ministradas)) {
      this.setState({dados: newProps.aulas_ministradas});
    }
  }
  handleChangeDateStartPicker(value, formattedValue) {
    this.setState({
      date_start: value,
      date_start_str: formattedValue,
    });
  }

  handleChangeDateFinishPicker(value, formattedValue) {
    this.setState({
      date_finish: value,
      date_finish_str: formattedValue,
    });
  }
  toggleCheckbox (index) {
    var self = this;
    index = parseInt(index);
    // Verifica-se se o checkbox está marcado ou desmarcado
    var data = this.state.dados_export_modal_materias;
    var ttms_ids = this.state.team_training_matter_staff_ids;
    var ttms_id = this.state.dados_export_modal_materias[index].id;
    if (this.state.dados_export_modal_materias[index].checked == true) {
      data[index].checked = false;
      ttms_ids[ttms_id]['checked'] = false;
    } else {
      data[index].checked = true;
      ttms_ids[ttms_id]['checked'] = true;
    }

    this.setState({team_training_matter_staff_ids: ttms_ids, data: data});
  }

  showModal(event) {
    var target = event.currentTarget.value;
    var url = config.get('api') + '/alunos/treinamento/titulo/'+target;
    var url_materias = config.get('api') + '/alunos/treinamento_materias_instrutor/'+target;

    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({titulo_modal_treinamento: responseJson.data});
        }
      }).catch((error) => {
        console.error(error);
      });
    });
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(url_materias, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({dados_modal_materias: responseJson.data});
          self.setState({ modal: true });
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  exportRPA() {
    this.props.handleAlert('', '', 'open');
    var datasave = {
      staff_id: this.props.staff_id,
      date_start_str: this.state.date_start_str,
      date_finish_str: this.state.date_finish_str,
      team_training_matter_staff_ids: this.state.team_training_matter_staff_ids,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/exportar/rpa/materias', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        if (responseJson.status === 'success') {
          window.open(config.get('cdn') + '/tmp/' + responseJson.data);
          self.props.handleAlert('', '', 'closed');
        } else {
         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  verifyRPA(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      staff_id: this.props.staff_id,
      date_start_str: this.state.date_start_str,
      date_finish_str: this.state.date_finish_str,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/instrutor/rpa/materias', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        if (responseJson.status === 'success') {
          self.setState({dados_export_modal_materias: responseJson.data});
          self.setState({team_training_matter_staff_ids: responseJson.team_training_matter_staff_ids});
          self.props.handleAlert('', '', 'closed');
        } else {
         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  botaoAcoes (cell, row) {
    var variavel = (
      <div className="btn-group">
        <button className="btn btn-info btn-sm" value={cell} onClick={this.showModal}>
            <i className="fa fa-fw fa-eye"></i>
        </button>
      </div>
    );

    return variavel;
  }
  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <h3 className="page-title">Treinamentos Ministrados pelo Instrutor</h3>
  <button title='Exportar registro individual de horas de treinamento' alt='Exportar registro individual de horas de treinamento' className="btn btn-default btn-sm" onClick={()=>this.setState({ modal_input: true })}><i className="fa fa-fw fa-money"></i></button>
  <hr/>
  <BootstrapTable data={this.state.dados} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: 'Exportar CSV', sizePerPage: 100, noDataText: 'Não há treinamentos ministrados para este instrutor'}} search={true} multiColumnSearch={true}  searchPlaceholder='Procurar'>

    <TableHeaderColumn dataField="turma" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Turma</TableHeaderColumn>

    <TableHeaderColumn isKey={true} dataField="treinamento" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Treinamento</TableHeaderColumn>

    <TableHeaderColumn dataField="date_start" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Data Inicial</TableHeaderColumn>

    <TableHeaderColumn dataField="date_finish" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Data Final</TableHeaderColumn>

    <TableHeaderColumn dataField="status" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Status</TableHeaderColumn>

    <TableHeaderColumn dataField="url_modal_materias" dataAlign="center" dataFormat={this.botaoAcoes} width='100'>Ações</TableHeaderColumn>

  </BootstrapTable>

  <Modal show={this.state.modal} bsSize="large" aria-labelledby="contained-modal-title-lg">
    <Modal.Header>
        <h4 className="pull-left">Matérias Ministradas - {this.state.titulo_modal_treinamento.turma_nome + " - " + this.state.titulo_modal_treinamento.treinamento_nome}</h4>
        <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false })}>
        <i className="fa fa-fw fa-close"></i></button>
        <div className="clearfix"></div>
    </Modal.Header>
    <Modal.Body>
      <BootstrapTable data={this.state.dados_modal_materias} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: 'Exportar CSV'}} search={true} multiColumnSearch={true}  searchPlaceholder='Procurar'>

        <TableHeaderColumn isKey={true} dataField="materia" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Matéria</TableHeaderColumn>

        <TableHeaderColumn dataField="date_start" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Data Inicial</TableHeaderColumn>

        <TableHeaderColumn dataField="date_finish" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Data Final</TableHeaderColumn>
      </BootstrapTable>
    </Modal.Body>
    <Modal.Footer>
        <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false })}>
        <i className="fa fa-fw fa-close"></i></button>
    </Modal.Footer>
  </Modal>
  <Modal show={this.state.modal_input} bsSize="large" aria-labelledby="contained-modal-title-lg">
    <Modal.Header>
        <h4 className="pull-left">Exportação registro individual de horas de treinamento</h4>
        <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal_input: false })}>
        <i className="fa fa-fw fa-close"></i></button>
        <div className="clearfix"></div>
    </Modal.Header>
    <Modal.Body>
      <form onSubmit={this.verifyRPA}>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>Data de Início:</label>
              <DatePicker onChange={this.handleChangeDateStartPicker} monthLabels={['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro']} dayLabels={['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb']} dateFormat={'DD/MM/YYYY'} placeholder="DD/MM/YYYY" value={this.state.date_start} />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>Data de Término:</label>
              <DatePicker onChange={this.handleChangeDateFinishPicker} monthLabels={['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro']} dayLabels={['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb']} dateFormat={'DD/MM/YYYY'} placeholder="DD/MM/YYYY" value={this.state.date_finish} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="form-group">
              <button type="submit" className="btn btn-primary btn-block"><i className="fa fa-search"></i> Buscar matérias no período</button>
            </div>
          </div>
        </div>
      </form>
      <table className="table table-bordered table-stripped table-hover">
        <thead>
          <tr>
            <th className="col-md-1 text-center">Exportar?</th>
            <th className="text-center">Codigo</th>
            <th className="text-center">Matéria</th>
            <th className="text-center">Assunto</th>
            <th className="text-center">Data Inicial</th>
            <th className="text-center">Data Final</th>
          </tr>
        </thead>
        <tbody id="suppliers-certifications">
          {Object.keys(self.state.dados_export_modal_materias).map(function(k) {
            return (
              <tr>
                <td className="text-center">
                  <input
                  name="payment_checked"
                  type="checkbox"
                  checked={self.state.dados_export_modal_materias[k].checked}
                  className="checkbox-filter-search"
                  onChange={() => { self.toggleCheckbox(k); }} />
                </td>
                <td className="text-center">{self.state.dados_export_modal_materias[k].code}</td>
                <td className="text-center">{self.state.dados_export_modal_materias[k].materia}</td>
                <td className="text-center">{self.state.dados_export_modal_materias[k].matter_subject}</td>
                <td className="text-center">{self.state.dados_export_modal_materias[k].date_start}</td>
                <td className="text-center">{self.state.dados_export_modal_materias[k].date_finish}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <div className="row">
        <div className="col-md-12">
          <div className="form-group">
            <button onClick={() => this.exportRPA()} className="btn btn-primary btn-block"><i className="fa fa-plus"></i> Exportar matérias selecionadas</button>
          </div>
        </div>
      </div>
    </Modal.Body>
    <Modal.Footer>
        <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal_input: false })}>
        <i className="fa fa-fw fa-close"></i></button>
    </Modal.Footer>
  </Modal>
</div>
    );
  }
}

export default StaffsMateriaMinistradaTab;



// WEBPACK FOOTER //
// ./src/Components/Staffs/Elements/StaffsMateriaMinistradaTab.js